export default "__VITE_ASSET__$Xzp4CY2__"